module.exports = __webpack_public_path__ + "img/unsei-chukichi.82268ea3.png";